import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import AppDialog from '#/modules/commonComponents/dialog/AppDialog';
import {
  dialogContentCompactGapClassName,
  dialogMdMaxWidthClassName,
} from '#/modules/commonComponents/dialog/dialogLayoutTokens';
import { PRODUCT_IN_USE_DOCUMENT_TYPE_LABELS } from '#/modules/crmMgmt/product/helper/apiError';

function documentDetailRoute(doc) {
  if (!doc?.id) {
    return null;
  }
  if (doc.documentType === 'CUSTOMER_ORDER') {
    return ROUTES.customerOrderDetail(doc.id);
  }
  if (doc.documentType === 'SALES_ORDER') {
    return ROUTES.salesOrderDetail(doc.id);
  }
  return null;
}

/**
 * 停用被 409 `CRM_PRODUCT_IN_USE` 擋下時，列出阻擋單據（後端最多回 20 筆）。
 */
const ProductInUseDialog = ({ open, onOpenChange, inUse }) => {
  const documents = inUse?.documents ?? [];
  const totalCount = inUse?.totalCount ?? documents.length;
  const omittedCount = inUse?.omittedCount ?? 0;

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="無法停用產品"
      description={`此產品仍被 ${totalCount} 張未結案的單據使用，請先結案或取消下列單據後再停用。`}
      maxWidthClassName={dialogMdMaxWidthClassName}
      contentClassName={dialogContentCompactGapClassName}
      onConfirm={() => onOpenChange(false)}
      confirmText="知道了"
      showCancel={false}
    >
      <ul className="m-0 list-none divide-y divide-slate-200 rounded-md border border-slate-200 p-0">
        {documents.map((doc) => {
          const to = documentDetailRoute(doc);
          return (
            <li
              key={`${doc.documentType}-${doc.id || doc.documentNo}`}
              className="flex items-center justify-between gap-3 px-3 py-2 text-sm"
            >
              <span className="shrink-0 text-muted-foreground">
                {PRODUCT_IN_USE_DOCUMENT_TYPE_LABELS[doc.documentType] || doc.documentType || '—'}
              </span>
              {to ? (
                <Link
                  to={to}
                  className="font-mono text-primary-600 underline-offset-2 hover:underline"
                  onClick={() => onOpenChange(false)}
                >
                  {doc.documentNo || '—'}
                </Link>
              ) : (
                <span className="font-mono">{doc.documentNo || '—'}</span>
              )}
            </li>
          );
        })}
      </ul>
      {omittedCount > 0 ? (
        <p className="text-xs text-muted-foreground">{`另有 ${omittedCount} 張未列出。`}</p>
      ) : null}
    </AppDialog>
  );
};

ProductInUseDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  inUse: PropTypes.shape({
    totalCount: PropTypes.number,
    omittedCount: PropTypes.number,
    documents: PropTypes.arrayOf(PropTypes.shape({
      documentType: PropTypes.string,
      documentNo: PropTypes.string,
      id: PropTypes.string,
    })),
  }),
};

export default ProductInUseDialog;
